const actions = {
  SET_STATE: 'user/SET_STATE',
  CREATE: 'instrument/CREATE',
   EDIT: 'instrument/EDIT'
}

export default actions
